import React, { useEffect, useNavigate } from 'react';
import logo from './logo.svg';

// import Header from "./components/header";
import TopMenu from "./components/topMenu";
import LeftMenu from "./components/leftMenu";
import DesignRightMenu from "./components/designRightMenu";
import LoadingSpinner from "./components/layout/spinner";
import Home from "./pages/home";
import SurveyDetail from "./pages/surveyDetail";
import UserSurvey from "./pages/userSurvey";
import { API, Auth, Hub } from 'aws-amplify';
import { withAuthenticator, useTheme, Heading, View, Image } from '@aws-amplify/ui-react';
import { setThemeMode} from "../../assessment/src/store/actions"
import { addUserEnvironmentFromAPI } from './services/userEnvironmentService';

import { Routes, Route, useLocation } from "react-router-dom";
import { PrimeReactProvider } from 'primereact/api';
import { useSelector,useDispatch } from 'react-redux';

import packageJson from '../package.json';

import logoBlack from '../src/assets/logo/maturytics_logo_black.svg';

import './App.css';
import '@aws-amplify/ui-react/styles.css';
// import '../src/custom-primeflex.css';
// import '/node_modules/primereact/resources/themes/lara-light-blue/theme.css';
// import 'primeicons/primeicons.css';

function AppWithoutAuth({ signOut, user }) {

  const themeMode = useSelector(state => state.themeMode);
  const leftMenuWidth = useSelector(state => state.leftMenuWidth);
  const rightMenuWidth = useSelector(state => state.rightMenuWidth);
//  const leftMenuVisibility = useSelector(state => state.leftMenuVisibility);
  const topMenuTabs = useSelector((state) => state.topMenuTabs);

  // const themeMode = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.themeMode;
  // const leftMenuWidth = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.leftMenuWidth;
  // const rightMenuWidth = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.rightMenuWidth;
  const leftMenuVisibility = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.leftMenuVisibility;
  const pageIsLoading = topMenuTabs.tabs.find((tab) => tab.id === topMenuTabs.activeTab).states.pageIsLoading;

  const location = useLocation();

  return (
    <div className={`flex flex-col min-h-[100vh] w-full overflow-hidden ${(themeMode === "dark" && !location.pathname.includes("/survey/")) ? "bg-[#14141f]" : "bg-[#fbfbfc]"}`} version={packageJson.version}>
      {!location.pathname.includes("/survey/") && (
        <div>
          <div className="fixed top-0 left-0 right-0 z-10">
            <TopMenu />
          </div>
          <div className="flex flex-1 overflow-hidden pt-[36px] min-h-[100vh]">
            <div className="w-26 h-full overflow-auto">
              <LeftMenu />
            </div>
            <div
              className="flex-1 overflow-y-auto overflow-x-hidden ml-0"
              style={{
                marginLeft: leftMenuVisibility === "hide" ? "0px" : `${leftMenuWidth}px`,
                marginRight: `${location.pathname.includes("/design") ? rightMenuWidth : "0"}px`
              }}
            >
              <div
                className={`w-full h-full flex border-b template-body ${themeMode === "dark" ? "bg-[#1a1a28] border-white/5" : "bg-[#FBFBFC] border-zinc-950/5"
                  }`}
              >
                <Routes className="flex-grow h-full">
                  <Route path="/" element={<Home />} />
                  <Route path="/home/*" element={<Home />} />
                  <Route path="/surveys/:survey_id/*" element={<SurveyDetail />} />
                  {/* <Route path="/survey/:user_survey_id/" element={<UserSurvey />} /> */}
                  {/* <Route path="/*" element={<Page404 />} /> */}
                </Routes>
              </div>
            </div>
            {location.pathname.includes("/design") && (
              <div className="w-26  h-full overflow-auto">
                <DesignRightMenu />
              </div>
            )}
          </div>
        </div>
      )}
      {location.pathname.includes("/survey/") && (
        <div>
          <Routes className="flex-grow h-full">
            <Route path="/survey/:user_survey_id/" element={<UserSurvey />} />
          </Routes>
        </div>
      )}
      {pageIsLoading && (
        <LoadingSpinner />
      )}
    </div>
  );
}


export default AppWithoutAuth;